import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function TruckTrollTag({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>TruckTrollTag</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8857 18.3242C14.8857 17.9212 14.5529 17.5945 14.1424 17.5945H11.6644C11.2538 17.5945 10.921 17.9212 10.921 18.3242C10.921 18.7272 11.2538 19.0539 11.6644 19.0539H14.1424C14.5529 19.0539 14.8857 18.7272 14.8857 18.3242Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3896 10.0539C14.3896 8.84488 13.3912 7.86475 12.1595 7.86475H4.23002C2.99834 7.86475 1.99986 8.84488 1.99986 10.0539V16.8647C1.99986 18.0738 2.99834 19.0539 4.23003 19.0539H4.56042C4.97098 19.0539 5.30381 18.7272 5.30381 18.3242C5.30381 17.9212 4.97098 17.5945 4.56042 17.5945H4.23003C3.81946 17.5945 3.48664 17.2678 3.48664 16.8647V10.0539C3.48664 9.65092 3.81946 9.32421 4.23002 9.32421H12.1595C12.57 9.32421 12.9029 9.65092 12.9029 10.0539V16.8647C12.9029 17.2678 12.57 17.5945 12.1595 17.5945H7.69916C7.2886 17.5945 6.95578 17.9212 6.95578 18.3242C6.95578 18.7272 7.2886 19.0539 7.69916 19.0539H12.1595C13.3912 19.0539 14.3896 19.0539 14.3899 17.3512L14.3896 10.0539Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3898 11.205C17.0736 10.9334 16.6677 10.7837 16.2476 10.7837H13.6464C13.2359 10.7837 12.903 11.1104 12.903 11.5134C12.903 11.9164 13.2359 12.2432 13.6464 12.2432H16.2476C16.3076 12.2432 16.3656 12.2645 16.4107 12.3033L18.7655 14.3259C18.8193 14.3721 18.8501 14.4388 18.8501 14.509V17.5945H17.6112C17.2006 17.5945 16.8678 17.9212 16.8678 18.3242C16.8678 18.7273 17.2006 19.054 17.6112 19.054H19.5935C20.0041 19.054 20.3369 18.7273 20.3369 18.3242V14.509C20.3369 14.018 20.121 13.5509 19.7446 13.2276L17.3898 11.205Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21222 18.081C6.62278 18.081 6.95561 18.4078 6.95561 18.8108C6.95561 19.2138 6.62278 19.5405 6.21222 19.5405C5.80166 19.5405 5.46883 19.2138 5.46883 18.8108C5.46883 18.4078 5.80166 18.081 6.21222 18.081ZM8.44238 18.8108C8.44238 17.6017 7.44391 16.6216 6.21222 16.6216C4.98054 16.6216 3.98206 17.6017 3.98206 18.8108C3.98206 20.0198 4.98054 21 6.21222 21C7.44391 21 8.44238 20.0198 8.44238 18.8108Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1243 18.081C16.5349 18.081 16.8677 18.4078 16.8677 18.8108C16.8677 19.2138 16.5349 19.5405 16.1243 19.5405C15.7138 19.5405 15.3809 19.2138 15.3809 18.8108C15.3809 18.4078 15.7138 18.081 16.1243 18.081ZM18.3545 18.8108C18.3545 17.6017 17.356 16.6216 16.1243 16.6216C14.8926 16.6216 13.8942 17.6017 13.8942 18.8108C13.8942 20.0198 14.8926 21 16.1243 21C17.356 21 18.3545 20.0198 18.3545 18.8108Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5925 6.93011C15.3482 6.24727 16.2952 5.87507 17.2852 5.92308C18.2737 5.971 19.1868 6.43177 19.8905 7.17697C20.1696 7.47254 20.1518 7.93425 19.8507 8.20822C19.5496 8.48219 19.0792 8.46468 18.8001 8.16911C18.3242 7.66514 17.7621 7.40744 17.2119 7.38076C16.6633 7.35416 16.0957 7.55547 15.5994 8.00391C15.2973 8.27685 14.827 8.25774 14.549 7.96122C14.2709 7.66469 14.2904 7.20305 14.5925 6.93011Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5337 4.8406C13.8251 3.64767 15.4624 2.98673 17.1661 3.0002C18.8697 3.01367 20.4979 3.70032 21.7735 4.91271C22.0685 5.19304 22.0761 5.65502 21.7905 5.94457C21.5049 6.23411 21.0343 6.24158 20.7394 5.96124C19.718 4.99058 18.449 4.46985 17.1542 4.45961C15.8595 4.44938 14.5849 4.94987 13.5526 5.90345C13.2537 6.17964 12.7832 6.16562 12.5018 5.87212C12.2205 5.57863 12.2347 5.1168 12.5337 4.8406Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
